type State = {
	idVeiculoTipo: number;
	descricao: string;
	codigoMarcaFipe: string;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number };

export const newBrandFormInitialState = {
	idVeiculoTipo: 0,
	descricao: '',
	codigoMarcaFipe: '',
};

export const newBrandFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				[action.field]: action.payload,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		default:
			return state;
	}
};
